<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="looksInactive()" (click)="onEnabledToggled()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="showGoldenBorder()">
    <app-autocomplete
      [allowAll]="false"
      [options]="itemTypeOptions()"
      [disabled]="isRowInactive()"
      [showOptions]="true"
      [selectedValues]="entry().itemTypes"
      (selectedValuesChange)="onItemTypesChanged($event)"></app-autocomplete>
    <span class="sep"></span>
    <app-select style="width: 125px; min-width: 125px;" [disabled]="looksInactive()" [(ngModel)]="entry().mode" (selectedValueChange)="onModeChanged($event)">
      <app-option [value]="FavouriteCurrencyMode.Multiplier" [text]="'Multiplier'"></app-option>
      <app-option [value]="FavouriteCurrencyMode.PromoteTier" [text]="'Promote Tier'"></app-option>
      <app-option [value]="FavouriteCurrencyMode.ForceVisible" [text]="'Force Visible'"></app-option>
    </app-select>
    @if (entry().mode !== FavouriteCurrencyMode.ForceVisible) {
      <span class="sep"></span>
      <input type="number" placeholder="value" pattern="[0-9.,]*" inputmode="decimal" step="any" class="form-control minmax" style="min-width: 55px;"
        [disabled]="looksInactive()"
        [(ngModel)]="entry().value" (ngModelChange)="onValueInputChanged($event)">
    }
    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn remove-btn" (click)="removeEntry()"></button>
    </span>
  </span>
</div>
